export default __webpack_public_path__ + "static/about-us-l5-img-4832c99c9476cbfdd1111c57b81dff7b.png";